import Dashboard from "views/Indicadores/Dashboard.js";
import Authenticate from "views/Auth/Authenticate.js";
import EsqueciSenha from "views/Auth/EsqueciSenha.js";
import Modulos from "views/Auth/Modulos.js";
import Inicio from "views/Setup/Inicio.js";
import UsuarioLista from "views/Setup/UsuarioLista.js";
import TrocarSenha from "views/Auth/TrocarSenha.js";

var routes = [
  {
    path: "/login",
    name: "Login",
    icon: "fas fa-chart-line",
    component: Authenticate,
    layout: "/auth",
    sidebar: false
  },
  {
    path: "/esquecisenha",
    name: "Esqueceu a Senha",
    icon: "fas fa-chart-line",
    component: EsqueciSenha,
    layout: "/auth",
    sidebar: false
  },
  {
    path: "/trocarsenha",
    name: "Trocar Senha",
    icon: "",
    component: TrocarSenha,
    layout: "/auth",
    sidebar: false
  },
  {
    path: "/modulos",
    name: "Modulos",
    icon: "fas fa-chart-line",
    component: Modulos,
    layout: "/auth",
    sidebar: false
  },
  {
    path: "/inicio",
    name: "Inicio",
    icon: "fas fa-home",
    component: Inicio,
    layout: "/setup",
    sidebar: true
  },
  {
    path: "/usuario",
    name: "Usuários",
    icon: "fas fa-users",
    component: UsuarioLista,
    layout: "/setup",
    sidebar: true
  },  
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "fas fa-chart-line",
    component: Dashboard,
    layout: "/indicadores",
    sidebar: false
  }
];
export default routes;
